/* eslint-disable indent */
// ==========================================
// DEPENDENCIAS Y RECURSOS
// ==========================================
import React from 'react';
import Modal from "react-modal";
import Header from '../Home/1-Header/Header';
import Footer from '../Home/3-Footer/Footer';
import FormEncuestaDatos from './FormEncuestaDatos/FormEncuestaDatos';
import api from '../../../api';
import './PagEncuesta.css';
import PageLoading from './FormEncuesta/PageLoading';
import RespuestaLlenada from './RespuestaEncuestaLlenada/RespuestaLlenada';

// ==========================================
// COMPONENTE PRINCIPAL
// ==========================================
export default class PagEncuesta extends React.Component {
  constructor(props) {
    super(props);

    // Un solo estado unificado, limpio y ordenado alfabéticamente/lógicamente
    this.state = {
      consulta: { resultado: [], cliente: [] },
      error: null,
      estado: "",
      id: this.props.match?.params?.idEncuesta || "",
      isVerified: false,
      loading: true,
      modal: false,
      mostrar: false,
      mostrarCaducidad: false,
      mostrarMensaje: false,
    };
  }

  // ==========================================
  // CICLO DE VIDA
  // ==========================================
  componentDidMount() {
    this.cargarEncuesta();
  }

  // ==========================================
  // MÉTODOS DE NEGOCIO / API
  // ==========================================
  async cargarEncuesta() {
    this.setState({ loading: true, error: null });

    try {

      const consultar = await api.IncidenciaCliente.traerIncidencia(this.state.id)
      const consultarCliente = await api.IncidenciaCliente.traerCliente(consultar.Resultado[0][0].Id_ClienteProveedor)

      if (!consultar || !consultar.Resultado || !consultar.Resultado[0]?.[0]) {
        this.setState({ mostrar: false, loading: false, mostrarMensaje: true });
        return;
      }

      const codEstado = consultar.Resultado[0][0].Cod_Estado;
      const nuevoResultado = [].concat(this.state.consulta.resultado, consultar.Resultado);
      const clienteResultado = [].concat(this.state.consulta.cliente, consultarCliente.Resultado);

      // Mapeo estructurado según el código de estado devuelto
      switch (codEstado) {
        case "003": // Encuesta disponible para llenar
          this.setState({
            mostrar: true,
            mostrarMensaje: false,
            loading: false,
            consulta: { 
              resultado: nuevoResultado,
              cliente:clienteResultado }
          });
          break;

        case "001": // En revisión
          this.setState({ estado: "Incidencia en revisión", modal: true, loading: false });
          break;

        case "002": // Anulada
          this.setState({ estado: "Incidencia Anulada", modal: true, loading: false });
          break;

        case "004": // Ya respondida
          this.setState({ estado: "Encuesta ya respondida", modal: true, loading: false });
          break;

        case "005": // Finalizada sin derecho a encuesta
          this.setState({ estado: "Incidencia finalizada", modal: true, loading: false });
          break;

        default: // Cualquier otro caso o error de código
          this.setState({
            mostrar: false,
            mostrarMensaje: true,
            loading: false,
            consulta: { resultado: nuevoResultado }
          });
          break;
      }

    } catch (error) {
      this.setState({ mostrar: false, error: error, loading: false });
    }
  }

  // ==========================================
  // MANEJADORES DE EVENTOS (HANDLERS)
  // ==========================================
  handleClose = (e) => {
    if (e) e.preventDefault();
    window.location.href = '/';
  }

  cerrarModal = (e) => {
    this.setState({ modal: false });
    this.handleClose(e);
  }

  // ==========================================
  // RENDERIZADO
  // ==========================================
  render() {
    const { loading, modal, id, estado, mostrar, consulta, mostrarMensaje } = this.state;

    // Vista de carga limpia
    if (loading) {
      return <PageLoading />;
    }

    return (
      <section className="encuesta-page-container">
        <Header />

        {/* CONTENEDOR DEL MODAL DE ESTADOS */}
        <div className="modal-wrapper">
          <Modal
            isOpen={modal}
            className="custom-modal-content"
            overlayClassName="custom-modal-overlay"
            onRequestClose={this.cerrarModal}
            ariaHideApp={false}
          >
            {/* Cabecera del Modal */}
            <div className="modal-header" style={{ padding: '20px', background: '#119EEF', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #334155', borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }}>
              <h3 style={{ margin: 0, color: '#f8fafc', fontSize: '18px' }}>Detalles del Soporte</h3>
              <button
                type="button"
                onClick={this.cerrarModal}
                className="btn-close"
                style={{ background: 'none', border: 'none', color: '#f8fafc', fontSize: '24px', cursor: 'pointer' }}
              >
                &times;
              </button>
            </div>

            {/* Cuerpo del Modal */}
            <div className="modal-body" style={{ padding: '25px' }}>
              <div style={{ marginBottom: '15px' }}>
                <span><b>Nro Ticket:</b> <span style={{ fontSize: 20 }}>{id}</span></span>
                <hr style={{ border: '0', height: '1px', background: '#334155', margin: '15px 0' }} />
              </div>

              <div className="info-grid">
                <p className="FormEncuesta__p" style={{ color: "#1e293b", textAlign: 'center', margin: '10% 0', fontSize: 22, fontWeight: '600' }}>
                  {estado}
                </p>
                <hr style={{ border: '0', height: '1px', background: '#cbd5e1', margin: '15px 0' }} />
                <p className="FormEncuesta__p" style={{ color: "#119EEF", textAlign: 'center', margin: 0, fontWeight: '500' }}>
                  Tu opinión es muy importante para nosotros
                </p>
              </div>
            </div>
          </Modal>
        </div>

        {/* CONTENEDOR PRINCIPAL DE FORMULARIOS */}
        <div className="PagEncuesta">
          <div className="PagEncuesta__FormEncuesta">
            <FormEncuestaDatos
              consultado={mostrar}
              RIncidencia={consulta}
            />
          </div>
        </div>

        <Footer />
      </section>
    );
  }
}


/* eslint-disable indent */
//Dependencies
/*
import React from 'react';
import Modal from "react-modal";
//Resorces
import Header from '../Home/1-Header/Header';
import Footer from '../Home/3-Footer/Footer';
import FormEncuestaDatos from './FormEncuestaDatos/FormEncuestaDatos';
import api from '../../../api';
import './PagEncuesta.css';
import PageLoading from './FormEncuesta/PageLoading';
import RespuestaLlenada from './RespuestaEncuestaLlenada/RespuestaLlenada';

export default class PagEncuesta extends React.Component {
  constructor(props) {
    super(props)

    this.state = { isVerified: false };

    this.state = {
      // id:"",
      id: this.props.match.params.idEncuesta,
      loading: true,
      mostrar: false,
      mostrarMensaje: false,
      mostrarCaducidad: false,
      modal: false,
      estado: "",
      consulta: {
        resultado: []
      },
    };

  }

  componentDidMount() {
    this.cargarEncuesta();
  }

  async handleClose(e) {
    window.location.href = '/';
  }

  async cargarEncuesta() {

    this.setState(
      {
        loading: true,
        error: null
      });

    try {

      console.log("============= Ejecucion =============");
      console.log(this.state.id);
      console.log("=====================================");

      const consultar = await api.IncidenciaCliente.traerIncidencia(this.state.id)

      console.log(consultar);

      console.log("============= Finalizacion =============");

      //184311
      if (consultar.Resultado[0][0].Cod_Estado === "003") {
        this.setState({
          mostrar: true, loading: false, mostrarMensaje: false,
          consulta: { resultado: [].concat(this.state.consulta, consultar.Resultado) }
        });

      }
      else if (consultar.Resultado[0][0].Cod_Estado === "001") {
        this.setState({
          estado: "Incidencia en revision",
          modal: true,
          loading: false,
        });
      }
      else if (consultar.Resultado[0][0].Cod_Estado === "002") {
        this.setState({
          estado: "Incidencia Anulada",
          modal: true,
          loading: false,
        });
      }
      else if (consultar.Resultado[0][0].Cod_Estado === "004") {
        this.setState({
          estado: "Encuesta ya respondida",
          modal: true,
          loading: false,
        });
      }
      else if (consultar.Resultado[0][0].Cod_Estado === "005") {
        this.setState({
          estado: "Incidencia finalizada",
          modal: true,
          loading: false,
        });
      }
      else {
        this.setState({
          mostrar: false, loading: false, mostrarMensaje: true,
          consulta: { resultado: [].concat(this.state.consulta, consultar.Resultado) }
        });

      }

    } catch (error) {
      this.setState({ mostrar: false, error: error, loading: false, });
    }
  };

  render() {
    if (this.state.loading) {
      return <PageLoading />;
    }
    return (
      <section>
        <Header />
        <div>

          <Modal
            isOpen={this.state.modal}
            className="custom-modal-content"
            overlayClassName="custom-modal-overlay"
            onRequestClose={(e) => {
              this.setState({ modal: false });
              this.handleClose(e);
            }}
            ariaHideApp={false}
          >
            <div className="modal-header" style={{ padding: '20px', background: '#119EEF', display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderBottom: '1px solid #334155', borderTopLeftRadius: '24px', borderTopRightRadius: '24px' }}>
              <h3 style={{ margin: 0, color: '#f8fafc', fontSize: '18px' }}>Detalles del Soporte</h3>
              <button
                type="button"
                onClick={(e) => {
                  this.setState({ modal: false });
                  this.handleClose(e);
                }}
                className="btn-close"
                style={{ background: 'none', border: 'none', color: '#f8fafc', fontSize: '24px', cursor: 'pointer' }}
              >
                &times;
              </button>
            </div>
            <div className="modal-body" style={{ padding: '25px' }}>
              <div>
                <span><b>Nro Ticket:</b> <span style={{ fontSize: 20 }}>{this.state.id}</span></span>
                <hr />
              </div>
              <div className="info-grid">
                <p className="FormEncuesta__p" style={{ color: "#1e293b", textAlign: 'center', marginTop: '20%', marginBottom: '20%', fontSize: 22 }}>
                  {this.state.estado}
                </p>
                <hr />
                <p className="FormEncuesta__p" style={{ color: "#119EEF", textAlign: 'center' }}>
                  Tu opinión es muy importante para nosotros
                </p>
              </div>
            </div>
          </Modal>

        </div>
        <div className="PagEncuesta">

          <div className="PagEncuesta__FormEncuesta">
            <FormEncuestaDatos
              consultado={this.state.mostrar}
              RIncidencia={this.state.consulta}
            />
            <RespuestaLlenada
              consultado={this.state.mostrarMensaje}
              RIncidencia={this.state.consulta}
            />
          </div>
        </div>
        <Footer />
      </section>
    )
  }

}
*/